import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import Document from './Document';
import { ListingDetails_ListingData_listing_property_media } from '../../../../../types/graph/ListingDetails_ListingData';

interface IProps {
  key: string;
  id: string;
  item: ListingDetails_ListingData_listing_property_media;
  index: any;
  active: any;
  onDeleteDocument: (arg: string) => void;
}

const SortableDocument: React.FC<IProps> = ({ id, active, ...props }) => {
  const sortable = useSortable({ id });
  const {
    attributes,
    listeners,
    isDragging,
    setNodeRef,
    transform,
    transition,
  } = sortable;

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: active === id ? 0 : 1,
  };

  return (
    <Document
      ref={setNodeRef}
      style={style}
      {...props}
      attributes={attributes}
      listeners={listeners}
    />
  );
};

export default SortableDocument;
